"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET_TYPE = exports.WIDGET_NAME = exports.FEATURE = exports.ELEMENT_TYPES = exports.ELEMENT_NAME = exports.ACTION = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
let FEATURE = /*#__PURE__*/function (FEATURE) {
  FEATURE["NOTIFICATION_PAGE"] = "notification-page";
  FEATURE["ANNOUNCEMENT_PAGE"] = "announcement-page";
  FEATURE["NOTIFICATION_FLYOUT"] = "notification-flyout";
  return FEATURE;
}({});
exports.FEATURE = FEATURE;
let WIDGET_NAME = /*#__PURE__*/function (WIDGET_NAME) {
  WIDGET_NAME["NOTIFICATIONS_TAB"] = "notifications-tab";
  WIDGET_NAME["MARK_ALL_AS_READ"] = "mark-all-as-read";
  WIDGET_NAME["EDIT_PREFERENCE"] = "edit-preference";
  WIDGET_NAME["NOTIFICATION_MESSAGE"] = "notification-message";
  WIDGET_NAME["MESSAGE_FLOATING_ACTIONS"] = "message-floating-actions";
  WIDGET_NAME["NOTIFICATIONS_TAB_GROUP"] = "notifications-tab-group";
  WIDGET_NAME["LEFT_RAIL_FILTERS"] = "left-rail-filters";
  return WIDGET_NAME;
}({});
exports.WIDGET_NAME = WIDGET_NAME;
let WIDGET_TYPE = /*#__PURE__*/function (WIDGET_TYPE) {
  WIDGET_TYPE["TAB"] = "tab";
  WIDGET_TYPE["BUTTON"] = "button";
  WIDGET_TYPE["CHECKBOX"] = "checkbox";
  WIDGET_TYPE["LINK"] = "link";
  WIDGET_TYPE["MENU_ITEM"] = "menu-item";
  WIDGET_TYPE["CHECKBOX_GROUP"] = "checkbox-group";
  WIDGET_TYPE["PICKER"] = "picker";
  WIDGET_TYPE["TAB_GROUP"] = "tab-group";
  WIDGET_TYPE["SWITCH"] = "switch";
  WIDGET_TYPE["NUMBER_FIELD"] = "number-field";
  WIDGET_TYPE["RADIO_GROUP"] = "radio-group";
  WIDGET_TYPE["INLINE_ALERT"] = "inline-alert";
  WIDGET_TYPE["VIEW"] = "view";
  return WIDGET_TYPE;
}({});
exports.WIDGET_TYPE = WIDGET_TYPE;
let ELEMENT_NAME = /*#__PURE__*/function (ELEMENT_NAME) {
  ELEMENT_NAME["VIEW_ALL_NOTIFICATION_FILTERS"] = "view-all-notification-filters";
  ELEMENT_NAME["ADOBE_STATUS_LINK"] = "adobe-status-link";
  ELEMENT_NAME["MARK_AS_READ_BUTTON"] = "mark as read button";
  ELEMENT_NAME["MARK_ALL_AS_READ_BUTTON"] = "mark all as read button";
  ELEMENT_NAME["VIEW_ALL_BUTTON"] = "view all button";
  return ELEMENT_NAME;
}({});
exports.ELEMENT_NAME = ELEMENT_NAME;
let ACTION = /*#__PURE__*/function (ACTION) {
  ACTION["CLICK"] = "click";
  ACTION["SELECT"] = "select";
  ACTION["CHANGE"] = "change";
  return ACTION;
}({});
exports.ACTION = ACTION;
let ELEMENT_TYPES = /*#__PURE__*/function (ELEMENT_TYPES) {
  ELEMENT_TYPES["TAB_LIST"] = "tab-list";
  ELEMENT_TYPES["INPUT"] = "input";
  ELEMENT_TYPES["MENU"] = "menu";
  ELEMENT_TYPES["BUTTON"] = "button";
  ELEMENT_TYPES["CHECKBOX"] = "checkbox";
  ELEMENT_TYPES["LINK"] = "link";
  return ELEMENT_TYPES;
}({});
exports.ELEMENT_TYPES = ELEMENT_TYPES;